import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
// routes
import { RouterLink } from 'src/routes/components';
// config
import { Box, useTheme } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useLocales } from 'src/locales';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { useLogoutMutation } from 'src/store/Reducer/auth';
import { clear } from 'src/store/slices/userSlice';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

export default function LoginButton({ sx }) {

  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useLocales();
  const dispatch = useDispatch();
  const { user } = useMockedUser();
  const [logout, { isLoading }] = useLogoutMutation();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();
  const deleteModal = useBoolean();


  const handleLogout = async () => {
    try {
      const response = await logout({ deviceId: '123456' });

      if (!response?.error) {
        deleteModal.onFalse();
        enqueueSnackbar(t('msg.logout_success'),{ variant: 'success' });

        dispatch(clear())

        localStorage.removeItem("persist:root");


        router.push("/");
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('msg.logout_error'), { variant: 'error' });
    }
  };
  const GoTo = () => {
    const isAdmin = user?.userType === "super-admin";
    const isOrganizer = user?.userType === "organizer";
    const isUser = user?.userType === "user";
    if (isAdmin) {
      router.push(paths.superAdminDashboard.root);
      return;
    }
    if (isOrganizer) {
      router.push(paths.orangizerDashboard.root);
      return;
    }
    if (isUser) {
      router.push(paths.dashboard.root);
      return;
    }

  }

  return (
    <>
      {user ? <>
        <Button
          onClick={deleteModal.onTrue}
          size='large'
          variant="contained"
          sx={{
            mr: 1, bgcolor: "primary.dark", color: "black",
            "&:hover": {
              bgcolor: "primary.main",
              color: "black",
            },
            ...sx
          }}>
          {t("home.logout")}
        </Button>
        <Button size='large' onClick={GoTo} variant="outlined" sx={{
          px: 3, mr: 1,
          border: `2px solid ${theme.palette.primary.dark}`, ...sx
        }}>
          {t("home.dashboard")}
        </Button>
      </> :
        <>
          <Button
            onClick={() => navigate(paths.auth.amplify.register, { state: "user" })}
            size='large'
            variant="contained"
            sx={{
              mr: 1, bgcolor: "primary.dark", color: "black",
              "&:hover": {
                bgcolor: "primary.main",
                color: "black",
              },
              ...sx
            }}>
            {t("home.register")}
          </Button>
          <Button component={RouterLink} size='large' href={paths.auth.amplify.login} variant="outlined" sx={{
            px: 3, mr: 1,
            border: `2px solid ${theme.palette.primary.dark}`, ...sx
          }}>
            {t("home.login")}
          </Button>
        </>
      }
      <ConfirmDialog
        maxWidth="xs"
        fullWidth
        title={t("home.logout")}
        content={t("home.logout_confirmation")}
        open={deleteModal.value}
        onClose={deleteModal.onFalse}
        action={
          <LoadingButton variant="contained" onClick={handleLogout} color="error" loading={isLoading}>{t("home.logout")}</LoadingButton>
        }
      />
    </>
  );
}
export function LoginButtonSmall({ sx }) {

  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useLocales();
  const dispatch = useDispatch();
  const { user } = useMockedUser();
  const [logout, { isLoading }] = useLogoutMutation();
  const router = useRouter();
  const deleteModal = useBoolean();
  const { enqueueSnackbar } = useSnackbar();



  const handleLogout = async () => {
    try {
      const response = await logout({ deviceId: '123456' });
      if (!response?.error) {

        deleteModal.onFalse();
        enqueueSnackbar(t('msg.logout_success'), { variant: 'success' });

        dispatch(clear())

        localStorage.removeItem("persist:root")

        router.push("/");
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('msg.logout_error'), { variant: 'error' });
    }
  };
  const GoTo = () => {
    const isAdmin = user?.userType === "super-admin";
    const isOrganizer = user?.userType === "organizer";
    const isUser = user?.userType === "user";
    if (isAdmin) {
      router.push(paths.superAdminDashboard.root);
      return;
    }
    if (isOrganizer) {
      router.push(paths.orangizerDashboard.root);
      return;
    }
    if (isUser) {
      router.push(paths.dashboard.root);
      return;
    }
  }
  console.log("user", user)
  return (
    <>
      {user ? <Box sx={{ marginTop: 2, display: { md: "none", xs: "flex" }, alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 2 }}>

        <Button size='large' onClick={GoTo} variant="outlined" sx={{ width: "90%", px: 3, mr: 1, border: `2px solid ${theme.palette.primary.dark}`, ...sx }}>
          {t("home.dashboard")}
        </Button>
        <Button
          onClick={deleteModal.onTrue}
          size='large'
          variant="contained"
          sx={{
            mr: 1, bgcolor: "primary.dark", color: "black",
            "&:hover": {
              bgcolor: "primary.main",
              color: "black",
            }, width: "90%", ...sx
          }}>
          {t("home.logout")}
        </Button>
      </Box> :
        <Box sx={{ marginTop: 2, display: { md: "none", xs: "flex" }, alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 2 }}>
          <Button
            onClick={() => navigate(paths.auth.amplify.register, { state: "user" })}
            size='large'
            variant="contained"
            sx={{
              mr: 1, bgcolor: "primary.dark", color: "black",
              "&:hover": {
                bgcolor: "primary.main",
                color: "black",
              }, width: "90%", ...sx
            }}>
            {t("home.register")}
          </Button>
          <Button component={RouterLink} size='large' href={paths.auth.amplify.login} variant="outlined" sx={{ width: "90%", px: 3, mr: 1, border: `2px solid ${theme.palette.primary.dark}`, ...sx }}>
            {t("home.login")}
          </Button>
        </Box>}
      <ConfirmDialog
        maxWidth="xs"
        fullWidth
        title={t("home.logout")}
        content={t("home.logout_confirmation")}
        open={deleteModal.value}
        onClose={deleteModal.onFalse}
        action={
          <LoadingButton variant="contained" onClick={handleLogout} color="error" loading={isLoading}>{t("home.logout")}</LoadingButton>
        }
      />
    </>
  );
}

LoginButton.propTypes = {
  sx: PropTypes.object,
};
